import React from 'react';
import Navbar from '../Components/Landingpage/Navbar';
import Footer from '../Components/Landingpage/Footer';
import BackToTop from '../Components/Landingpage/BackToTop';
import { getCompanyName, getEmail, getAddress, getLegalInfo } from '../data/companyDetails';

const TermsConditions = () => {
  const companyName = getCompanyName();
  const email = getEmail();
  const address = getAddress();
  const legal = getLegalInfo();

  return (
    <>
      <Navbar />
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <h1 className="display-4 mb-4 text-primary">Terms and Conditions</h1>
              <p className="text-muted mb-4">Last updated: {legal.lastUpdated}</p>
              
              <div className="mb-5">
                <p className="lead mb-4">
                  We ({companyName}) are deeply concerned about your privacy and we take this concern very seriously. This Privacy Policy ("Privacy Policy") sets out how we collect, process, use and may disclose your data when you use our mobile application and its versions ("App"). The App is referred to as the "Platform". References to "we", "our" or "us" or the "MASTISHORTS" shall mean the Platform and/or {companyName}. Any references to "you", "your" or "user" shall mean any person or entity using our Platform. We will not use or share your information with anyone except as described in this Privacy Policy.
                </p>
                <p>
                  This Privacy Policy is a part of and is to be read with the Term of Use ("Terms"). By using this Platform, you agree to the terms and conditions of this Privacy Policy. You also consent to our use and disclosure of your Personal Information (as defined below) in the manner described in this Privacy Policy. The capitalized words used in this Privacy Policy but not defined here in, shall have the meaning given to such words in the Terms. If you do not agree with the terms and conditions of this Privacy Policy, please do not use this Platform.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="text-primary mb-3">The information we collect and how we use it</h3>
                <p>The following table lists the information we collect from you and how we use it:</p>
                
                <div className="row mb-4">
                  <div className="col-md-6">
                    <h5 className="text-secondary">Information We Collect</h5>
                  </div>
                  <div className="col-md-6">
                    <h5 className="text-secondary">How We Use It</h5>
                  </div>
                </div>

                <div className="bg-light p-4 rounded mb-4">
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To set up and facilitate log-in to a user account on Platform</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To notify you about changes to the Platform, including this Privacy Policy</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To facilitate communication through the Platform, phone and email, including provision of user support and enablement of services</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To enforce our terms, conditions, and policies and any of our rights, or the rights of our affiliate companies, or other users of the Platform</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To develop new services and improve the existing services and the Platform and integrate user feedback and requests</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To provide language and location based personalization</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To administer the Platform and for internal operations, including troubleshooting, data analysis, testing, research, security, fraud-detection, account management, and survey purposes</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To better understand how you use and access the Platform and to improve the user experience on the Platform</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To pseudonymise and aggregate your information, including Personal Information, for conducting user demographic analysis</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To upload or create replicable profiles on associated/sister platforms operated by us or the Group</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To assess effectiveness of and improve advertising and other marketing and promotional activities</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To provide you quick access to your previous searches and use analytics for personalization</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To verify your identity and maintain account security</li>
                    <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> To provide suggestions and invite your friends and other contacts to the platform</li>
                  </ul>
                </div>
              </div>

              <div className="mb-5">
                <h3 className="text-primary mb-3">Disclosure of your information</h3>
                <p>We disclose your information in the following manner:</p>

                <div className="mb-4">
                  <h5 className="text-secondary mb-3">Content visible to others</h5>
                  <p>
                    Public Content i.e., any content you post on your user profile or on another user's profile, such as a post comment is accessible to everyone, including search engines. Any information you voluntarily disclose for posting to the Platform, including your profile page information, is accessible to anyone. When you submit, post or share the content that you choose to make public on the Platform, it may be re-shared by others. You should consider who you choose to share it with, because people who can see your activity on our Platform can choose to share it with others on and off our Platform, including people outside the audience you shared it with.
                  </p>
                </div>

                <div className="mb-4">
                  <h5 className="text-secondary mb-3">Sharing with our group of companies</h5>
                  <p>
                    We may share information that you share with us including your Personal Information with any member of our Group. The term "Group" shall mean any entity that is controlled by us, or any entity that is in control of us, or any entity that is under common control with us, whether directly or indirectly.
                  </p>
                </div>

                <div className="mb-4">
                  <h5 className="text-secondary mb-3">What you share with Others</h5>
                  <p>
                    When you share content and communicate using our Platform, you choose the audience for what you share. For example, when you post any content from our Platform on Facebook, you select the audience for the post, such as a friend, a group of friends or all of your friends. Similarly, when you use WhatsApp or any other application on your mobile device to share the content on our Platform, you choose who you share the content with.
                  </p>
                </div>

                <div className="mb-4">
                  <h5 className="text-secondary mb-3">Sharing with Third Parties</h5>
                  <p>We may share your information (including Personal Information) with select third parties including:</p>
                  <ul>
                    <li>Business partners, suppliers and sub-contractors ("Affiliates")</li>
                    <li>Advertisers and advertising networks that require the data to select and serve relevant adverts</li>
                    <li>Government bodies or law enforcement agencies, if required by law</li>
                  </ul>
                </div>
              </div>

              <div className="mb-5">
                <h3 className="text-primary mb-3">Security Practices</h3>
                <p>
                  We have in place appropriate technical and security measures to secure the information collected by us. Where we have given you (or where you have chosen) a username and password which enables you to access the Platform, you are responsible for keeping these details confidential. We ask you not to share your password with anyone.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="text-primary mb-3">Where we store your personal information</h3>
                <p>
                  We store your data with Amazon Web Services cloud platform provided by Amazon Web Services, Inc. (headquartered at 410 Terry Ave. N Seattle, Washington 98109, USA) and also on Google Cloud Platform provided by Google LLC (headquartered at 1101 S Flower St, Burbank, California 91502, USA) on their servers located in India and abroad. Both Amazon Web Services and Google Cloud Platform implement security measures to protect the loss, misuse and alteration of the information.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="text-primary mb-3">Changes To this policy</h3>
                <p>
                  The Company may periodically update this Privacy Policy. Whenever we make any changes to this Privacy Policy that are important for you to know about, we will post the updated Privacy Policy at this link.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="text-primary mb-3">Your Rights</h3>
                <p>
                  You are free to remove or delete content from your user account/profile and your account/profile at any point in time. However, the history of your activities and account on our Platform remains available to us. You may correct, amend, add or delete Personal Information from your account at any time by logging in and visiting your profile page.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="text-primary mb-3">Data Retention</h3>
                <p>
                  We do not retain your Sensitive Personal Information for longer than is required for the purposes for which the information may be lawfully used. For any other content, we will entertain your request for deletion, however, there is a strong possibility that copies of any public content will be retained indefinitely in our systems.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="text-primary mb-3">Music Labels</h3>
                <p>
                  By virtue of the App being a short-video platform, we have entered into music license agreements with various music labels in order to ensure optimal user experience on the Platform. Information pertaining to music data might be shared with such music labels from time to time in an anonymized manner.
                </p>
              </div>

              <div className="mb-5">
                <h3 className="text-primary mb-3">Communications from us</h3>
                <p>
                  We may from time to time send you service-related announcements when we consider it necessary to do so (such as when we temporarily suspend the Platform for maintenance, or security, privacy, or administrative-related communications). We send these to you via SMS. You may not opt-out of these service-related announcements, which are not promotional in nature and used solely to protect your account and keep you informed of important changes to the Platform.
                </p>
              </div>

              <div className="mb-5 bg-primary text-white p-4 rounded">
                <h3 className="text-white mb-3">Contact Information</h3>
                <div className="row">
                  <div className="col-md-8">
                    <h5 className="text-white">{companyName}</h5>
                    <p className="mb-2">
                      <i className="fas fa-map-marker-alt me-2"></i>
                      {address}
                    </p>
                    <p className="mb-0">
                      <i className="fas fa-envelope me-2"></i>
                      <a href={`mailto:${email}`} className="text-white">{email}</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
};

export default TermsConditions;
